import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { IdentityServiceBase } from '@seahorse/auth';
import { catchError } from 'rxjs/operators';

export const portalResponseInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {
  const _identityService = inject(IdentityServiceBase);

  const handleError = (error: HttpErrorResponse) => {
    switch (error.status) {
      case 401:
        _identityService.clearIdentity(true);
        break;
      default:
        break;
    }
  };

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      handleError(error);
      throw error;
    })
  );
};
